import { Locale } from '@ps-smart-cp/ppfw-client';

const laArtPrinRepaySchedRptTypeClassConfig = {
  principalRepaymentScheduleSummary: new Map([[Locale.ja, 'リース物件元本返済予定表(集計表)']]),
  principalRepaymentScheduleStatement: new Map([[Locale.ja, 'リース物件元本返済予定表(明細表)']]),
};

export { laArtPrinRepaySchedRptTypeClassConfig };
